export default class MarkdownService {
  public static removeMarkdown(text: string): string {
    let output = text.replaceAll(/^(-\s*?|\*\s*?|_\s*?){3,}\s*/gm, "");
    output = output.replaceAll(/<[^>]*>/g, "");
    return output
      .replace(/([\*]+)(\S)(.*?\S)??\1/g, "$2$3")
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} #{0,}(\n)?\s{0,}$/gm, "$1$2$3")
      .replace(/(`{3,})(.*?)\1/gm, "$2")
      .replace(/`(.+?)`/g, "$1");
  }
}
